import { render, staticRenderFns } from "./DeactivateDiscount.vue?vue&type=template&id=011fba48&"
import script from "./DeactivateDiscount.vue?vue&type=script&lang=js&"
export * from "./DeactivateDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports